document.addEventListener('DOMContentLoaded', () => {
  const DISCOUNT_KITS = 3

  const cartItems = document.querySelector('.cart-items')
  const subtotalAmount = document.querySelector('.subtotal-amount')
  const totalAmount = document.querySelector('.total-amount')
  const drawerForm = document.querySelector('.drawer__form')

  var drawer = function () {
    /**
     * Element.closest() polyfill
     * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
     */
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector
      }
      Element.prototype.closest = function (s) {
        var el = this
        var ancestor = this
        if (!document.documentElement.contains(el)) return null
        do {
          if (ancestor.matches(s)) return ancestor
          ancestor = ancestor.parentElement
        } while (ancestor !== null)
        return null
      }
    }

    //
    // Settings
    //
    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',
    }

    //
    // Methods
    //

    // Toggle accessibility
    var toggleccessibility = function (event) {
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false)
      } else {
        event.setAttribute('aria-expanded', true)
      }
    }

    // Open Drawer
    var openDrawer = function (trigger) {
      // Find target
      var target = document.getElementById(
        trigger.getAttribute('aria-controls'),
      )

      // Add class to body
      document.querySelector('body').classList.add('off-canvas-body')

      // Make it active
      target.classList.add(settings.activeClass)

      // Toggle accessibility
      toggleccessibility(trigger)

      // Make it visible
      setTimeout(function () {
        target.classList.add(settings.visibleClass)
      }, settings.speedOpen)

      fetchItems()
    }

    // Close Drawer
    var closeDrawer = function (event) {
      // Find target
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector(
          '[aria-controls="' + closestParent.id + '"',
        )

      document.querySelector('body').classList.remove('off-canvas-body')

      // Make it not visible
      closestParent.classList.remove(settings.visibleClass)

      // Toggle accessibility
      toggleccessibility(childrenTrigger)

      // Make it not active
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass)
      }, settings.speedClose)
    }

    // Click Handler
    var clickHandler = function (event) {
      // Find elements
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        close = toggle.closest(settings.selectorClose)

      // Open drawer when the open button is clicked
      if (open) {
        openDrawer(open)
      }

      // Close drawer when the close button (or overlay area) is clicked
      if (close) {
        closeDrawer(close)
      }

      // Prevent default link behavior
      if (open || close) {
        event.preventDefault()
      }
    }

    // Keydown Handler, handle Escape button
    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        // Find all possible drawers
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i

        // Find active drawers and close them when escape is clicked
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeDrawer(drawers[i])
          }
        }
      }
    }

    //
    // Inits & Event Listeners
    //
    document.addEventListener('click', clickHandler, false)
    document.addEventListener('keydown', keydownHandler, false)
  }

  fetchItems()

  drawer()

  // Show subtotal
  function showSubtotalAmount(subtotal) {
    if (subtotalAmount) subtotalAmount.innerHTML = `$${subtotal / 100}`
  }

  // Show total price if required
  function showTotalPrice(total) {
    if (totalAmount) {
      totalAmount.innerHTML = `$${total / 100}`
    }
  }

  // Get items from cart
  function fetchItems() {
    fetch('/cart.js')
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        // console.log(data)
      })

    fetch('/cart.js')
      .then((resp) => resp.json())
      .then(renderItems)
  }

  // If no items in the cart show message and hide checkout form
  function ifCartIsEmpty(data) {
    if (data.items.length === 0) {
      cartItems.innerHTML = "<p class='cart__empty'>The cart is empty</p>"
      if (drawerForm) drawerForm.style.display = 'none'
    } else {
      if (drawerForm) drawerForm.style.display = 'block'
    }
  }

  // Helper function to check if product title is a bundle variant
  // It's a bit hacky, but variants typically have `/` in their names
  // we split on that and verify that all the parts look like licenses
  const isVariantBundle = (variant_title) => {
    if (!variant_title) return false

    const parts = variant_title.split(' / ')

    // If we don't have multiple parts, it's not a bundle
    if (parts.length <= 1) return false

    // Also hacky to hard code, but the best I can do :/
    const licenseKeywords = ['INDIVIDUAL', 'SMALL BUSINESS', 'ENTERPRISE']
    return parts.every((part) =>
      licenseKeywords.some((keyword) => part.trim().includes(keyword)),
    )
  }

  // Helper to simplify bundle variant titles
  const simplifyBundleVariant = (variant_title) => {
    if (!isVariantBundle(variant_title)) return variant_title

    const licenses = variant_title.split('/')
    // Check if all licenses are the same
    if (licenses.every((license) => license.trim() === licenses[0].trim())) {
      // Return just one license type, properly cased
      return (
        licenses[0].trim().charAt(0).toUpperCase() +
        licenses[0].trim().slice(1).toLowerCase()
      )
    }
    return variant_title
  }

  // Listing items template
  function listDOM(data) {
    data.items.forEach(function (product) {
      const { image, product_title, variant_title, final_price, id } = product
      if (!cartItems) return

      // Simplify the variant title if it's a bundle
      const displayVariantTitle = simplifyBundleVariant(variant_title)

      cartItems.insertAdjacentHTML(
        'beforeend',
        `
          <div class="cart-item">
            <div class="cart-item-content">
              <div class="cart-item-thumbnail"
                style="background-image: url(${image})">
              </div>
              <div class="cart-item-desc">
                <p class="title button-2">${product_title}</p>
                <p class="color-yellow">${displayVariantTitle}</p>
                <p class="body-3">$${final_price / 100}</p>
              </div>
            </div>

            <button class="cart-item-remove" aria-label="Remove item" role="button" data-id="${id}">
              <svg viewBox="0 0 121 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M120.5 14.3827L106.117 0L60.4567 45.6606L14.8827 0L0.5 14.3827L46.1606 59.9567L0.5 105.617L14.8827 120L60.4567 74.3393L106.117 120L120.5 105.617L74.8393 59.9567L120.5 14.3827Z"
                  fill="white"/>
              </svg>
            </button>
          </div>`,
      )
    })
  }

  // Function to remove items from cart
  function removeItemsFromCartFeature() {
    const cartItemRemove = document.querySelectorAll('.cart-item-remove')

    cartItemRemove.forEach((item) => {
      item.addEventListener('click', (e) => {
        let target = e.target
        if (target !== item) {
          target = e.target.closest('.cart-item-remove')
        }
        let changedItem = {
          id: target.dataset.id,
          quantity: 0,
        }
        const config = {
          method: 'POST',
          body: JSON.stringify(changedItem),
          headers: {
            'Content-Type': 'application/json',
          },
        }

        const RemoveFromCartEvent = new CustomEvent('remove-from-cart', {
          detail: {
            config,
            onSucceed: renderItems,
            onFail: (e) => console.log(e),
          },
        })

        document
          .querySelector('cart-notification')
          .dispatchEvent(RemoveFromCartEvent)
      })
    })
  }

  // List items from cart
  function renderItems(data) {
    if (cartItems) {
      cartItems.innerHTML = ''
    }

    ifCartIsEmpty(data)

    listDOM(data)

    showSubtotalAmount(data.items_subtotal_price)

    showTotalPrice(data.total_price)

    removeItemsFromCartFeature()
  }
}) // End of DOMContentLoaded event
